'use strict';
module.exports = function queueFadeOut(element, theme) {
	const removeElement = () => {
		return element.remove();
	};
	if (!element) {
		return;
	}
	if (!theme || theme.noAnimations()) {
		return removeElement();
	}
	if (element.ownerDocument && element.ownerDocument.activeElement === element && element.parentElement) {
		const closestFocusableParent = element.parentElement.closest('[tabindex]');
		if (closestFocusableParent) {
			closestFocusableParent.focus();
		}
	}
	element.setAttribute('id', '');
	element.setAttribute('removal-queued', 'true');
	element.addEventListener('transitionend', removeElement);
	element.style.opacity = 0;
	setTimeout(removeElement, 500);
};

